

import React, { useEffect, useMemo, useRef, useState } from 'react';
import MapView from '@arcgis/core/views/MapView';
import Map from '@arcgis/core/Map';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import GroupLayer from '@arcgis/core/layers/GroupLayer';
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Home from "@arcgis/core/widgets/Home";
import Popup from "@arcgis/core/widgets/Popup";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Expand from "@arcgis/core/widgets/Expand.js";
import Graphic from "@arcgis/core/Graphic.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Legend from '@arcgis/core/widgets/Legend';  // Import Legend Widget
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Table from './Table';
import { setSelectedBuffer } from "../store/slice/bufferSlice";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Loader from './Loader';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { setIsDrgaTable, setIsSidebar } from '../store/slice/currentStageSlice';
import { setIsBufferWidth } from '../store/slice/currentStageSlice';
const MapComponent = ({ selectedLayer, onViewReady, isWidth, isScreenSize, isByDefaultActive, locationAi,graph }) => {
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation()
  const [view, setView] = useState(null);
  const [isDrag, setIsDrag] = useState(false);
  const [isAccordian, setIsAccordian] = useState('');
  const [tabLocation, setTabLocation] = useState(false);
  const [isLayerListExpanded, setIsLayerListExpanded] = useState(false);
  const [updatedTableData, setUpdatedTableData] = useState([]);
  const { bufferData, selectedBuffer, setFeatureTable } = useSelector((state) => state.buffer);
  const features = bufferData[selectedBuffer] || [];
  const [isScreenSize1, setIsScreenSize1] = useState(window.innerWidth <= 991);
  const [loading, setLoading] = useState(true); // Loader state
  const { isBufferWidth, isToolHeight, currentStageValue, isSideBar } = useSelector((state) => state.currentStage);
  const { isDistCd, isUlbCd, isWardNo } = useSelector((state) => state.currentStage)

  const authData = useSelector(state => state.authToken.authData);


  console.log("isDistCd", isDistCd)
  console.log("isUlbCd", isUlbCd)
  console.log("isWardNo", isWardNo)

  const handleDrag = () => {
    setIsDrag(!isDrag)
    setIsDrgaTable(isDrag)
      console.log("isDragisDragisDragisDrag", isDrag)
  }

  // Layer URLs and titles
  const layerUrls = [
    //Admin Boundary  0-13
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/1", title: "State" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/2", title: "Division" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/3", title: "District" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/4", title: "Tehsil" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/5", title: "Municipal Area" , isMunicipalArea: true },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/6", title: "Municipal Zone Boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/7", title: "Municipal Ward Boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/8", title: "Municipal Taxratezone Boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/9", title: "Cantonment Areas" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/10", title: "Planning_area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/11", title: "Urbanagglomerationarea" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/12", title: "Village_boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/13", title: "Khasra" },
    //Property 14-27
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/14", title: "Property" },
    //{ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97", title: "MP Property" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/15", title: "Plot Building Structure" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/16", title: "BuiltUp Area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/17", title: "Spatial DistributionOf Slums" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/18", title: "VillageSettlement Boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/19", title: "VillageSettlementy_bfp" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/20", title: "Temporary Shades" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/21", title: "Commercial Boundary" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/22", title: "Planning BuiltupArea" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/23", title: "PowerPlant" },
    // { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/24", title: "MP Grid" },
    // { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/25", title: "MP Grid Slum" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/26", title: "Slum DemarcationPoint" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/27", title: "Ward Gazzete NotificationPoints" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/28", title: "Slum Gazatte NotificationPoint" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/29", title: "TaxRate Gazette NotificationPoint" },

    //Land use Land Cover 27-42
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/30", title: "Agricultural Area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/31", title: "Existing Landuse" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/32", title: "Forest" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/33", title: "Vacantlands" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/34", title: "Wastelands" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/35", title: "Hillarea" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/36", title: "Openland" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/37", title: "Traffic_island" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/38", title: "Playground" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/39", title: "Industrial_area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/40", title: "Minning_area" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/41", title: "Plantation" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/42", title: "Orchyard" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/43", title: "Park" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/44", title: "Planning_lulc" },

    //Transportation

    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/45", title: "RoadCenterline", popupEnabled: Popup , isRoadCenterline: true },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/46", title: "Road_polygon", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/47", title: "RoadEdgeLine", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/48", title: "Divider", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/49", title: "Flyover", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/50", title: "Lane", popupEnabled: Popup },

    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/51", title: "Footpath", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/52", title: "Bridge_poi", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/53", title: "Bridge_line", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/54", title: "Bridge_poly", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/55", title: "Culvert", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/56", title: "RailwayCenterline", popupEnabled: Popup },


    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/57", title: "Railway_poly", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/58", title: "Railway_property", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/59", title: "RailwayStation", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/60", title: "Railway_gate", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/61", title: "AirCraftRoad", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/62", title: "Airport_poi", popupEnabled: Popup },

    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/63", title: "Helipad", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/64", title: "Busstand", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/65", title: "Planning_RoadCenterline", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/66", title: "Planning_RailwayCenterline", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/67", title: "Planning_Railwaypoly", popupEnabled: Popup },

    //Waterbodies
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/68", title: "RiverCenterline", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/69", title: "Rivers", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/70", title: "Drainage or Nala", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/71", title: "Drains", popupEnabled: Popup },

    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/72", title: "Obscured Drain", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/73", title: "Canal Centerline", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/74", title: "Canals", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/75", title: "WaterBodies", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/76", title: "Dam", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/77", title: "OverheadTank", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/78", title: "Wells", popupEnabled: Popup },

    //Important Landmarks

    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/79", title: "Importantlandmarks", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/80", title: "ColonyName", popupEnabled: Popup },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/81", title: "Villagelocation", popupEnabled: Popup },

    //Utilities
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/82", title: "Electrical Network" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/83", title: "FireStation" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/84", title: "Markets" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/85", title: "Pipeline" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/86", title: "Telecommunication" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/87", title: "Toilets" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/88", title: "Trafficmgmt" },



    //Others
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/89", title: "Telecommunication" },
    { url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer/90", title: "Toilets" },


    //{ url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97", title: "MP Property information" },




  ];

  useEffect(() => {
    if (location.pathname === "/user-chatbot") {
      console.log("i am gis")
      setTabLocation(true)
    }
  }, [location])




  useEffect(() => {
    let mapView; // Store the mapView reference
    const initializeMap = async () => {
      try {
        setLoading(true);

        // const towns = ["UJJAIN", "SINGRAULI", "SHIVPURI", "SEONI", "SATNA", "SAGAR", "PITHAMPUR", "OMKARESHWAR", "NEEMUCH", "NAGDA", "MORENA", "KHARGONE", "HOSHNGABAD", "GWALIOR", "GUNA", "DATIA", "DAMOH", "DABRA", "CHHINDWARA", "CHHATARPUR", "BURHANPUR", "BHIND", "BETUL", "ASHOKNAGAR"];

        // const masterPlanLayers = towns.map((town) =>
        //   new FeatureLayer({
        //     url: "https://urbangis.mp.gov.in/server/rest/services/Master_Plan_MIL1/MapServer/0",
        //     outFields: ["*"],
        //     visible: false,
        //     title: town,
        //     //definitionExpression: `Town_Name = '${town}'`,
        //   })
        // );

        // const masterPlanGroup = new GroupLayer({
        //   title: "Master Plan",
        //   // visible: false,
        //   visible: false,
        //   layers: masterPlanLayers,

        // });


        const towns = ["UJJAIN", "SINGRAULI", "SHIVPURI", "SEONI", "SATNA", "SAGAR", "PITHAMPUR", "OMKARESHWAR", "NEEMUCH", "NAGDA", "MORENA", "KHARGONE", "HOSHNGABAD", "GWALIOR", "GUNA", "DATIA", "DAMOH", "DABRA", "CHHINDWARA", "CHHATARPUR", "BURHANPUR", "BHIND", "BETUL", "ASHOKNAGAR"];

        const masterPlanLayers = towns.map((town) => {
          const layerConfig = {
            //url: "https://urbangis.mp.gov.in/server/rest/services/Master_Plan_MIL1/MapServer/0",
             url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/master_plan/MapServer/3",
            outFields: ["*"],
            visible: true,
            title: town
          };

          // Apply filter only for Viewer role and if town matches user's district
          if (authData?.UserType === "User") {
            // Convert district name to uppercase to match town names
            const userDistrict = authData?.DistrictName?.toUpperCase();

            // Only show the master plan for the user's district
            if (town === userDistrict) {
              layerConfig.definitionExpression = `Town_Name = '${town}'`;
              layerConfig.visible = true; // Make the matching layer visible
            }
          } else {
            // For non-Viewer roles, keep all towns available but not visible by default
            layerConfig.definitionExpression = `Town_Name = '${town}'`;
          }

          return new FeatureLayer(layerConfig);
        });

        const masterPlanGroup = new GroupLayer({
          title: "Master Plan",
          visible: false,
          layers: masterPlanLayers
        });


        // const group1 = new GroupLayer({
        //   title: "Administrative Boundaries",
        //   visible: true,
        //   layers: layerUrls.slice(0, 13).map((layer, index) =>
        //     new FeatureLayer({
        //       url: layer.url,
        //       title: layer.title,
        //       // //definitionExpression: `dist_cd = '454' AND ulb_cd = '0477'`,
        //      // visible: index % 2 === 0,
        //     })
        //   )
        // });





        // const group1 = new GroupLayer({
        //   title: "Administrative Boundaries",
        //   visible: true,
        //   layers: layerUrls.slice(0, 13).map((layer, index) => {
        //     const layerDef = {
        //       url: layer.url,
        //       title: layer.title
        //     };

        //     // Apply filters based on layer type and user role

        //     if (authData?.UserRole === "Viewer") {
        //       // District layer (index 2)
        //       if (index === 2) {
        //         layerDef.definitionExpression = `dist_cd = '${authData?.DistrictCode}'`;
        //       }
        //       // ULB layer (index 4)

        //       // else if (index === 4) {
        //       //   layerDef.definitionExpression = `dist_cd = '${authData?.DistrictCode}' AND ulb_cd = '${authData?.Ulb_Code}'`;
        //       // }

        //        if (index === 4) { // Municipal Area layer
        //       layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
        //     }

        //       // Ward layer (index 6)
        //       // else if (index === 6) {
        //       //   layerDef.definitionExpression = `dist_cd = '${authData?.DistrictCode}' AND ulb_cd = '${authData?.Ulb_Code}' AND wardno = '${authData?.WardNo}'`;
        //       // }

        //        else if (index === 6) { // Municipal Ward Boundary
        //       layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
        //     }


        //       // Other admin boundary layers
        //       else {
        //         layerDef.definitionExpression = `dist_cd = '${authData?.DistrictCode}'`;
        //       }
        //     }



        //     // Apply filters based on layer type
        //     // if (index === 4) { // Municipal Area layer
        //     //   layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
        //     // }
        //     // else if (index === 6) { // Municipal Ward Boundary
        //     //   layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
        //     // }

        //     return new FeatureLayer(layerDef);
        //   })
        // });


        // const group1 = new GroupLayer({
        //   title: "Administrative Boundaries",
        //   visible: true,
        //   layers: layerUrls.slice(0, 13).map((layer, index) => {
        //     const layerDef = {
        //       url: layer.url,
        //       title: layer.title
        //     };



        //     // Apply filters based on layer type
        //     if (index === 4) { // Municipal Area layer (ULB boundary)
        //       layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
        //       layerDef.visible = true; // Make sure it's visible
        //     }
        //     else if (index === 6) { // Municipal Ward Boundary
        //       // Only show wards for the selected ULB
        //       layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
        //     }
        //     else if (index === 2) { // District layer
        //       // Show the district that contains the ULB
        //       layerDef.definitionExpression = `dist_cd = '${authData?.DistrictCode}'`;
        //     }


        //     else {
        //       // Hide other administrative boundaries by default
        //       layerDef.visible = false;
        //     }

        //     return new FeatureLayer(layerDef);
        //   })
        // });


        const group1 = new GroupLayer({
          title: "Administrative Boundaries",
          visible: true,
          layers: layerUrls.slice(0, 13).map((layer, index) => {
            const layerDef = {
              url: layer.url,
             // maxScale: 18000, // Zoom level ~15
             maxScale: 1128, // restricts zoom in to level 20
              title: layer.title,
               visible: [0, 2, 4].includes(index) // Only layers 0, 2, and 4 are visible
            };

             //color change
            // Apply dark blue color specifically to Municipal Area
            if (layer.isMunicipalArea) {
              layerDef.renderer = {
                type: "simple",
                symbol: {
                  type: "simple-fill", // For polygon features
                  color: null, // Dark blue with 50% opacity
                  outline: {
                    color: [0, 0, 139], // Dark blue outline
                    width: 2
                  }
                }
              };
            }


            if (authData?.UserType === "User") {
              // Apply filters only for viewers
              if (index === 4) { // Municipal Area layer (ULB boundary)
                layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
                layerDef.visible = true;
              } else if (index === 6) { // Municipal Ward Boundary
                layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
              } else if (index === 2) { // District layer
                layerDef.definitionExpression = `dist_cd = '${authData?.DistrictCode}'`;
              } else {
                layerDef.visible = false;
              }
            } else {
              // For non-viewers, skip applying filters but still control visibility
              if (index !== 4 && index !== 6 && index !== 2) {
                layerDef.visible = false;
              }
            }

            return new FeatureLayer(layerDef);
          })
        });



        // const group2 = new GroupLayer({
        //   title: "Property",

        //   visible: false,

        //   layers: layerUrls.slice(13, 26).map(layer =>
        //     new FeatureLayer({
        //       url: layer.url,
        //       title: layer.title,
        //       //definitionExpression: `dist_cd = '454' AND ulb_cd = '0477'`,
        //       //popupTemplate,
        //       // definitionExpression: `dist_cd = '${isDistCd}' AND ulb_cd = '${isUlbCd}' AND ward_no = '${isWardNo}'`
        //       // definitionExpression: definitionExpression
        //     })
        //   )
        // });


        // const group2 = new GroupLayer({
        //   title: "Property",
        //   visible: false,
        //   layers: layerUrls.slice(13, 26).map(layer => {
        //     const layerDef = {
        //       url: layer.url,
        //       title: layer.title
        //       // definitionExpression: `ulb_cd = '${authData?.Ulb_Code}'` // Apply to all property layers
        //     };

        //     if (authData?.UserRole === "Viewer") {
        //       // Property layer (index 14)
        //       if (layer.title === "Property") {
        //         layerDef.definitionExpression = `dist_cd = '${authData?.DistrictCode}' AND ulb_cd = '${authData?.Ulb_Code}' AND wardno = '${authData?.WardNo}'`;
        //       }
        //       // Other property-related layers
        //       else {
        //         layerDef.definitionExpression = `dist_cd = '${authData?.DistrictCode}' AND ulb_cd = '${authData?.Ulb_Code}'`;
        //       }
        //     }

        //     return new FeatureLayer(layerDef);
        //   })
        // });

        const group2 = new GroupLayer({
          title: "Property",
          visible: false, // Keep property layers hidden by default
          layers: layerUrls.slice(13, 26).map(layer => {
            const layerDef = {
              url: layer.url,
              title: layer.title,
              visible: true // Hide all property layers by default
            };

            // Apply filters based on layer type and user role
            if (authData?.UserType === "User") {
              // Property layer (index 14)
              if (layer.title === "Property") {
                layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
                layerDef.visible = true; // Only make the main Property layer visible
              }
              // Other property-related layers (like BuiltUp Area, Commercial Boundary etc.)
              else if (["BuiltUp Area", "Commercial Boundary", "Plot Building Structure"].includes(layer.title)) {
                layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
              }
              // For other property-related layers, keep them hidden
              else {
                layerDef.definitionExpression = `1=0`; // This ensures no features will show
              }
            } else {
              // For non-Viewer roles, still filter by ULB but keep visible
              //layerDef.definitionExpression = `ulb_cd = '${authData?.Ulb_Code}'`;
              layerDef.definitionExpression = '1=1';
            }

            return new FeatureLayer(layerDef);
          })
        });

        // Helper function to get definition expression based on layer type

        // const getDefinitionExpression = (layerTitle, authData) => {
        //   if (authData?.UserRole !== "Viewer") return "";

        //   // Common filter for most layers - restrict to district
        //   let expression = `dist_cd = '${authData.DistrictCode}'`;

        //   // More specific filters for certain layer types
        //   switch (layerTitle.toLowerCase()) {
        //     case "municipal area":
        //     case "property":
        //     case "builtup area":
        //     case "commercial boundary":
        //       expression += ` AND ulb_cd = '${authData.Ulb_Code}'`;
        //       break;

        //     case "municipal ward boundary":
        //     case "property info":
        //       expression += ` AND ulb_cd = '${authData.Ulb_Code}' AND wardno = '${authData.WardNo}'`;
        //       break;

        //     // Special cases for specific layers if needed
        //     case "slum demarcationpoint":
        //       expression += ` AND ulb_cd = '${authData.Ulb_Code}'`;
        //       break;
        //   }

        //   return expression;
        // };




        // // const group3 = new GroupLayer({
        // //   title: "Landuse and Landcover",
        // //   visible: false,

        // //   layers: layerUrls.slice(27, 42).map(layer =>
        // //     new FeatureLayer({
        // //       url: layer.url,
        // //       title: layer.title,
        // //       //definitionExpression: `dist_cd = '454' AND ulb_cd = '0477'`,
        // //       // popupTemplate,
        // //     })
        // //   )
        // // });

        // // const group4 = new GroupLayer({
        // //   title: "Transportation",
        // //   visible: true,
        // //   layers: layerUrls.slice(42, 65).map(layer =>
        // //     new FeatureLayer({
        // //       url: layer.url,
        // //       title: layer.title,
        // //       //definitionExpression: `dist_cd = '454' AND ulb_cd = '0477'`,
        // //       // popupTemplate,
        // //     })
        // //   )
        // // });

        // // const group5 = new GroupLayer({
        // //   title: "Waterbodies",
        // //   visible: false,
        // //   layers: layerUrls.slice(65, 76).map(layer =>
        // //     new FeatureLayer({
        // //       url: layer.url,
        // //       title: layer.title,
        // //       //definitionExpression: `dist_cd = '454' AND ulb_cd = '0477'`,
        // //       // popupTemplate,
        // //     })
        // //   )
        // // });

        // // const group6 = new GroupLayer({
        // //   title: "Important Landmarks",
        // //   visible: false,
        // //   layers: layerUrls.slice(76, 79).map(layer =>
        // //     new FeatureLayer({
        // //       url: layer.url,
        // //       title: layer.title,
        // //       //definitionExpression: `dist_cd = '454' AND ulb_cd = '0477'`,
        // //       //popupTemplate,
        // //     })
        // //   )
        // // });

        // // const group7 = new GroupLayer({
        // //   title: "Utilities",
        // //   visible: false,
        // //   layers: layerUrls.slice(79, 86).map(layer =>
        // //     new FeatureLayer({
        // //       url: layer.url,
        // //       title: layer.title,
        // //       //definitionExpression: `dist_cd = '454' AND ulb_cd = '0477'`,
        // //       //popupTemplate,
        // //     })
        // //   )
        // // });

        // // const group8 = new GroupLayer({
        // //   title: "Others",
        // //   visible: false,
        // //   layers: layerUrls.slice(86, 88).map(layer =>
        // //     new FeatureLayer({
        // //       url: layer.url,
        // //       title: layer.title,
        // //       //definitionExpression: `dist_cd = '454' AND ulb_cd = '0477'`,
        // //       // popupTemplate,
        // //     })
        // //   )
        // // });


        // // Apply filtering to all group layers
        // const group3 = new GroupLayer({
        //   title: "Landuse and Landcover",
        //   visible: true,
        //   layers: layerUrls.slice(27, 42).map(layer =>
        //     new FeatureLayer({
        //       url: layer.url,
        //       title: layer.title,
        //       definitionExpression: getDefinitionExpression(layer.title, authData),
        //       // popupTemplate,
        //     })
        //   )
        // });

        // const group4 = new GroupLayer({
        //   title: "Transportation",
        //   visible: true,
        //   layers: layerUrls.slice(42, 65).map(layer =>
        //     new FeatureLayer({
        //       url: layer.url,
        //       title: layer.title,
        //       definitionExpression: getDefinitionExpression(layer.title, authData),
        //       // popupTemplate,
        //     })
        //   )
        // });

        // const group5 = new GroupLayer({
        //   title: "Waterbodies",
        //   visible: true,
        //   layers: layerUrls.slice(65, 76).map(layer =>
        //     new FeatureLayer({
        //       url: layer.url,
        //       title: layer.title,
        //       definitionExpression: getDefinitionExpression(layer.title, authData),
        //       // popupTemplate,
        //     })
        //   )
        // });

        // const group6 = new GroupLayer({
        //   title: "Important Landmarks",
        //   visible: true,
        //   layers: layerUrls.slice(76, 79).map(layer =>
        //     new FeatureLayer({
        //       url: layer.url,
        //       title: layer.title,
        //       definitionExpression: getDefinitionExpression(layer.title, authData),
        //       //popupTemplate,
        //     })
        //   )
        // });

        // const group7 = new GroupLayer({
        //   title: "Utilities",
        //   visible: true,
        //   layers: layerUrls.slice(79, 86).map(layer =>
        //     new FeatureLayer({
        //       url: layer.url,
        //       title: layer.title,
        //       definitionExpression: getDefinitionExpression(layer.title, authData),
        //       //popupTemplate,
        //     })
        //   )
        // });

        // const group8 = new GroupLayer({
        //   title: "Others",
        //   visible: true,
        //   layers: layerUrls.slice(86, 88).map(layer =>
        //     new FeatureLayer({
        //       url: layer.url,
        //       title: layer.title,
        //       definitionExpression: getDefinitionExpression(layer.title, authData),
        //       // popupTemplate,
        //     })
        //   )
        // });


        // const viewMISLayer = new MapImageLayer({
        //   url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer",

        //   sublayers: [
        //     {
        //       id: 97,
        //       title: "Property Info",
        //       visible: true,
        //       // //definitionExpression: `dist_cd = '454' AND ulb_cd = '0477'`,
        //       // definitionExpression:definitionExpression,
        //       // definitionExpression: `dist_cd = '454' AND ulb_cd = '0477' AND wardno = '06'`,
        //       //definitionExpression: `dist_cd = ${isDistCd} AND ulb_cd = ${isUlbCd} AND wardno = ${isWardNo}`,
        //       //definitionExpression: `dist_cd = '${isDistCd}' AND ulb_cd = '${isUlbCd}' AND wardno = '${isWardNo}'`,

        //       popupEnabled: true,
        //       popupTemplate: {
        //         title: "MIS Feature Info",
        //         content: [
        //           {
        //             type: "fields",
        //             fieldInfos: [
        //               { fieldName: "ulbname", label: "ULB" },
        //               { fieldName: "wardno", label: "Ward" },
        //               { fieldName: "ownername", label: "Owner" },
        //               { fieldName: "e_nagarpalikaid", label: "E Nagarpalika ID" },
        //               { fieldName: "gis_uniqueid", label: "GIS Unique ID" },
        //               { fieldName: "isuseres", label: "Is Use Residential" }
        //             ]
        //           }
        //         ]
        //       }
        //     }
        //   ]
        // });


        // Enhanced helper function to get definition expression based on layer type
        const getDefinitionExpression = (layerTitle, authData) => {
          // For non-Viewer roles, show all data (no filter)
          if (authData?.UserType !== "User") return "";

          // Base filter for all layers - restrict to district
          let expression = `dist_cd = '${authData.DistrictCode}'`;

          // Convert layer title to lowercase for case-insensitive comparison
          const layerLower = layerTitle.toLowerCase();

          // Apply ULB filter to all layers that should be ULB-specific
          if ([
            // Administrative boundaries
            'municipal area', 'municipal zone boundary', 'municipal ward boundary',
            'municipal taxratezone boundary', 'planning_area', 'urbanagglomerationarea',

            // Property-related
            'property', 'plot building structure', 'builtup area', 'commercial boundary',
            'temporary shades', 'planning builtuparea', 'slum demarcationpoint',
            'ward gazzete notificationpoints', 'slum gazatte notificationpoint',
            'taxrate gazette notificationpoint',

            // Land use
            'existing landuse', 'vacantlands', 'industrial_area', 'planning_lulc',

            // Transportation
            'roadcenterline', 'road_polygon', 'roadedgeline', 'divider', 'flyover',
            'lane', 'footpath', 'bridge_poi', 'bridge_line', 'bridge_poly', 'culvert',
            'railwaycenterline', 'railway_poly', 'railway_property', 'railwaystation',
            'railway_gate', 'aircraftroad', 'airport_poi', 'helipad', 'busstand',
            'planning_roadcenterline', 'planning_railwaycenterline', 'planning_railwaypoly',

            // Waterbodies
            'rivercenterline', 'rivers', 'drainage or nala', 'drains', 'obscured drain',
            'canal centerline', 'canals', 'waterbodies', 'dam', 'overheadtank', 'wells',

            // Landmarks and utilities
            'importantlandmarks', 'colonyname', 'villagelocation', 'electrical network',
            'firestation', 'markets', 'pipeline', 'telecommunication', 'toilets',
            'trafficmgmt',
            //mis data
            'vw_pro_mis_ow_flo'

          ].some(term => layerLower.includes(term.toLowerCase()))) {
            expression += ` AND ulb_cd = '${authData.Ulb_Code}'`;
          }

          // Special cases with additional filters
          switch (layerLower) {
            case 'municipal ward boundary':
            case 'property info':
              expression += ` AND wardno = '${authData.WardNo}'`;
              break;

            case 'slum demarcationpoint':
              // Additional filters for slums if needed
              break;

            // Add other special cases as needed
          }

          return expression;
        };

        // Apply this to all group layers
        const group3 = new GroupLayer({
          title: "Landuse and Landcover",
          visible: false, // Hidden by default
          layers: layerUrls.slice(27, 42).map(layer =>
            new FeatureLayer({
              url: layer.url,
              title: layer.title,
              definitionExpression: getDefinitionExpression(layer.title, authData),
              visible: layer.title === "Existing Landuse" // Only show key layers by default
            })
          )
        });

        // const group4 = new GroupLayer({
        //   title: "Transportation",
        //   visible: true,
        //   layers: layerUrls.slice(42, 65).map(layer =>
        //     new FeatureLayer({
        //       url: layer.url,
        //       title: layer.title,
        //        minScale: 288895.277144,   // Zoom level 12
        //       maxScale: 70.5310735  ,    // Restrict zoom beyond this scale
        //       definitionExpression: getDefinitionExpression(layer.title, authData),
        //       visible: ["RoadCenterline", "RailwayCenterline"].includes(layer.title) // Show main road layers
        //     })
        //   )
        // });

         const group4 = new GroupLayer({
          title: "Transportation",
          visible: true,
          layers: layerUrls.slice(42, 65).map(layer => {
            const layerDef = {
              url: layer.url,
              title: layer.title,
              minScale: 288895.277144,
              maxScale: 70.5310735,
              definitionExpression: getDefinitionExpression(layer.title, authData),
              visible: ["RoadCenterline", "RailwayCenterline"].includes(layer.title)
            };

            // Apply grey color specifically to RoadCenterline
            if (layer.isRoadCenterline) {
              layerDef.renderer = {
                type: "simple",
                symbol: {
                  type: "simple-line",
                  color: [128, 128, 128], // Grey color
                  width: 1
                }
              };
            }

            return new FeatureLayer(layerDef);
          })
        });


        const group5 = new GroupLayer({
          title: "Waterbodies",
          visible: false,
          layers: layerUrls.slice(65, 76).map(layer =>
            new FeatureLayer({
              url: layer.url,
              title: layer.title,
              definitionExpression: getDefinitionExpression(layer.title, authData),
              visible: ["Rivers", "WaterBodies"].includes(layer.title) // Show main water features
            })
          )
        });

        const group6 = new GroupLayer({
          title: "Important Landmarks",
          visible: false,
          layers: layerUrls.slice(76, 79).map(layer =>
            new FeatureLayer({
              url: layer.url,
              title: layer.title,
              definitionExpression: getDefinitionExpression(layer.title, authData)
            })
          )
        });

        const group7 = new GroupLayer({
          title: "Utilities",
          visible: false,
          layers: layerUrls.slice(79, 86).map(layer =>
            new FeatureLayer({
              url: layer.url,
              title: layer.title,
              definitionExpression: getDefinitionExpression(layer.title, authData)
            })
          )
        });

        const group8 = new GroupLayer({
          title: "Others",
          visible: false,
          layers: layerUrls.slice(86, 88).map(layer =>
            new FeatureLayer({
              url: layer.url,
              title: layer.title,
              definitionExpression: getDefinitionExpression(layer.title, authData)
            })
          )
        });


         //sewarage 

        const sewerageProjectLayer = new MapImageLayer({
          url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer",
          sublayers: [
            {
              id: 1,
              title: "STP",
              visible: true
            },
            {
              id: 2,
              title: "MPS",
              visible: true
            },
            {
              id: 3,
              title: "IPS",
              visible: true
            },
            {
              id: 4,
              title: "Manhole",
              visible: true
            },
            {
              id: 5,
              title: "Sewer Network",
              visible: true
            }
          ]
        });


        // Create a group layer to contain the sewerage layers
        const sewerageGroupLayer = new GroupLayer({
          title: "Sewerage Project Layers",
          visible: false,
          layers: [sewerageProjectLayer]
        });

        //watersupply_project

        const watersupplyProjectLayer = new MapImageLayer({
          url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer",
          sublayers: [
            {
              id: 1,
              title: "WTP",
              visible: true
            },
            {
              id: 2,
              title: "Intake Well",
              visible: true
            },
            {
              id: 3,
              title: "OHT",
              visible: true
            },
            {
              id: 4,
              title: "Junction",
              visible: true
            },
            {
              id: 5,
              title: "RWPM",
              visible: true
            },
            {
              id: 6,
              title: "CWPM",
              visible: true
            },
            {
              id: 7,
              title: "Distribution Network",
              visible: true
            }
          ]
        });


        // Create a group layer to contain the sewerage layers
        const watersupplyGroupLayer = new GroupLayer({
          title: "Watersupply Project Layers",
          visible: false,
          layers: [watersupplyProjectLayer]
        });



        //sampda_guideline


        const SampadaGuidelineLayer = new MapImageLayer({
          url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sampda_guideline/MapServer",
          // url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/sampda_guideline/MapServer/1",
          sublayers: [
            {
              id: 1,
              title: "Sampada Guideline",
              visible: true
            }

          ]
        });


        // Create a group layer to contain the sewerage layers
        const sampadaGuidelineGroupLayer = new GroupLayer({
          title: "Sampada Guideline ",
          visible: false,
          layers: [SampadaGuidelineLayer]
        });



        // const viewMISLayer = new MapImageLayer({
        //   url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer",
        //   sublayers: [
        //     {
        //       id: 97,
        //       title: "Property Info",
        //       visible: true,
        //      // definitionExpression: authData?.UserRole === "Viewer"
        //       //  ? `dist_cd = '${authData?.DistrictCode}' AND ulb_cd = '${authData?.Ulb_Code}' AND wardno = '${authData?.WardNo}'`
        //      //   : undefined,
        //       popupEnabled: true,
        //       popupTemplate: {
        //         title: "MIS Feature Info",
        //         content: [/* ... */]
        //       }
        //     }
        //   ]
        // });


        const popupTemplate = {
          title: "Property Info",
          content: function (feature) {
            const attributes = feature.graphic.attributes;

            // Determine the label based on isuseres
            let label = "";
            switch (attributes.isuseres) {
              case "Yes":
                label = "Residential";
                break;
              case "No":
                label = "Commercial";
                break;
              case "Mix Use":
                label = "Both";
                break;
              default:
                label = attributes.isuseres || "N/A";
            }

            return `
            <div style="min-height: 300px; overflow-y: auto;">
              <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
                <tr>
                  <th style="border: 1px solid #ddd; padding: 4px;">Field</th>
                  <th style="border: 1px solid #ddd; padding: 4px;">Value</th>  
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Ulb Name:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.ulbname}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>GIS Uniqueid ID:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.gis_uniqueid}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>E_NagarPalika ID:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.e_nagarpalikaid}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Property Type:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${label}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Wardno:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.wardno}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Owner Name:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.ownername}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Mobile No:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.mobileno}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Plot Size:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.plotsize}</td>
                </tr>
                <tr>
                  <td style="border: 1px solid #ddd; padding: 2px;"><b>Floor Details:</b></td>
                  <td style="border: 1px solid #ddd; padding: 2px;">${attributes.floor_details}</td>
                </tr>
               
              </table>
            </div>`;
          }
        };

        //   const PropertyFeatureLayer = new FeatureLayer({
        //   url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97",
        //   outFields: ["*"],
        //  popupTemplate: popupTemplate,
        //  // minScale: 18000, // Zoom level ~15
        //   // maxScale: 70,    // Zoom level ~25
        //   // definitionExpression: authData?.UserRole === "Viewer"
        // //? `dist_cd = '${authData?.DistrictCode}' AND ulb_cd = '${authData?.Ulb_Code}' AND wardno = '${authData?.WardNo}'`
        //   // : undefined,
        //   // minScale: 1128, // Zoom level 18
        //   // maxScale: 70,   // Zoom level 23
        //   // maxScale: 18,   // Zoom level 25 (~1:18)
        //   renderer: {
        //     type: "simple", // Use SimpleRenderer for all features
        //     symbol: {
        //       type: "simple-fill", // For polygon or multipolygon features
        //      // color: "lightgreen", // Fill color
        //        color: null, // Fill color
        //       outline: {
        //        // color: "#006400", // Dark green outline
        //         color: "#90EE90", // Light green outline
        //         width: 1
        //       }
        //     }
        //   }

        // });


        // const PropertyFeatureLayer = new FeatureLayer({
        //   url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97",
        //   outFields: ["*"],
        //   popupTemplate: popupTemplate,
        //  // minScale: 18000, // Zoom level ~15
        //   maxScale: 70,    // Zoom level ~25
        //   renderer: {
        //     type: "simple",
        //     symbol: {
        //       type: "simple-fill",
        //       color: null,
        //       outline: {
        //         color: "#90EE90",
        //         width: 1
        //       }
        //     }
        //   },
        //   // Add definitionExpression based on user role
        //    definitionExpression: authData?.UserRole === "Viewer"
        //      ? `ulb_cd = '${authData?.Ulb_Code}' AND wardno = '${authData?.WardNo}'`
        //      : undefined
        // });

        const getPropertyLayerDefinition = () => {
          if (authData?.UserType === "User") {
            try {
              // const expression = `ulb_cd = '${authData?.Ulb_Code}' AND wardno = '${authData?.WardNo}'`;
              const expression = `ulb_cd = '${authData?.Ulb_Code}'`;
              console.log("Applying PropertyFeatureLayer filter:", expression);
              return expression;
            } catch (error) {
              console.error("Error creating definition expression:", error);
              return undefined;
            }
          }
          return undefined;
        };

        const PropertyFeatureLayer = new FeatureLayer({
          url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97",
          outFields: ["*"],
           title: "Property Info",
          popupTemplate: popupTemplate,
        minScale: 1128.497220 , // Zoom level ~19
          maxScale: 70.5310735,     // Zoom level ~23
         // maxScale: 70,
          renderer: {
            type: "simple",
            symbol: {
              type: "simple-fill",
              color: null,
              outline: {
                color: "#90EE90",
                width: 1
              }
            }
          },
          definitionExpression: getPropertyLayerDefinition()
        });
        const map = new Map({
         // basemap: "topo-vector",
          basemap: "topo-vector",//,topo-vector ,streets ,hybrid ,satellite
          layers: [sampadaGuidelineGroupLayer, watersupplyGroupLayer, sewerageGroupLayer,PropertyFeatureLayer, masterPlanGroup, group8, group7, group6, group5, group4, group3, group2, group1],
        });

        mapView = new MapView({
          container: mapRef.current,
          popup: new Popup({
            defaultPopupTemplateEnabled: true,
            dockEnabled: true,
            dockOptions: {
              // dock popup at bottom-right side of view
              buttonEnabled: false,
              breakpoint: false,
              position: "bottom-right"
            }
          }),

          map: map,
          center: [78.746567, 23.83403],
          zoom: 6,
        });


        mapView.when(async () => {
          setLoading(false);

          

          //zoom

          // If Viewer role, zoom to their ULB (Municipal Area)
          if (authData?.UserType === "User") {
            try {
              // Find the Municipal Area layer (ULB level)
              const ulbLayer = map.layers.find(layer =>
                layer.title === "Municipal Area" ||
                (layer.layers && layer.layers.find(l => l.title === "Municipal Area"))
              );

              // If we found the layer in a group
              const actualUlbLayer = ulbLayer?.layers?.find(l => l.title === "Municipal Area") || ulbLayer;

              if (actualUlbLayer) {
                // Query the extent of the filtered ULB
                const query = actualUlbLayer.createQuery();
                query.where = `dist_cd = '${authData?.DistrictCode}' AND ulb_cd = '${authData?.Ulb_Code}'`;
                query.returnGeometry = true;
                query.outSpatialReference = mapView.spatialReference;

                const result = await actualUlbLayer.queryFeatures(query);

                console.log("result", result);

                if (result.features.length > 0) {
                  // Combine all feature extents into one
                  let combinedExtent = result.features[0].geometry.extent;

                  result.features.slice(1).forEach(feature => {
                    combinedExtent = combinedExtent.union(feature.geometry.extent);
                  });

                  // Zoom to the ULB extent with some padding
                  mapView.goTo(combinedExtent.expand(1.5));
                }
              }
            } catch (error) {
              console.error("Error zooming to ULB extent:", error);
            }
          }


          //final shashi

          const layerList = new LayerList({
            view: mapView,
            listItemCreatedFunction: function (event) {
              const item = event.item;
              // Add a zoom action to each town layer item
              if (item.layer.type === "feature") {
                item.actionsSections = [
                  [
                    {
                      title: "Zoom to Town",
                      className: "esri-icon-zoom-in-magnifying-glass",
                      id: "zoom-town",
                    },
                  ],
                ];
              }
            },
          });



          // Add event listener to LayerList for zooming
          layerList.on("trigger-action", (event) => {
            if (event.action.id === "zoom-town") {
              const layer = event.item.layer;
              const townName = layer.title;

              layer.when(() => {
                const query = layer.createQuery();
                query.where = `Town_Name = '${townName}'`;
                query.returnGeometry = true;
                query.outSpatialReference = mapView.spatialReference;
                layer.queryFeatures(query).then((result) => {
                  if (result.features.length > 0) {
                    // Combine all feature extents into one
                    let combinedExtent = result.features[0].geometry.extent;

                    result.features.slice(1).forEach((feature) => {
                      combinedExtent = combinedExtent.union(feature.geometry.extent);
                    });

                    mapView.goTo(combinedExtent.expand(0.8));
                  } else {
                    alert("No geometry found for this town.");
                  }
                });
              });
            }
          });
          const layerListExpand = new Expand({
            view: mapView,
            content: layerList,
            expanded: isLayerListExpanded,
          });

          mapView.ui.add(layerListExpand, "top-right");

          if (onViewReady) onViewReady(mapView);
        });

       mapView.ui.remove("zoom");

          mapView.ui.add(new Search({ view: mapView }), { position: "top-left", index: 2 })
          mapView.ui.add(new Home({ view: mapView }), "top-left");
          mapView.ui.add(new ScaleBar({ view: mapView }), "bottom-right");
          mapView.ui.add(new Expand({ view: mapView, content: new BasemapGallery({ view: mapView }) }), "top-left");
          mapView.ui.add(new Locate({ view: mapView, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-left");

        //Print

        
        mapView.when(() => {

          const printWidget = new Print({
            view: mapView,
           // printServiceUrl:"https://urbangis.mp.gov.in/server/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
             printServiceUrl:"https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"

          });

          // Add print widget in an Expand
          const expandPrint = new Expand({
            view: mapView,
            content: printWidget
          });

          mapView.ui.add(expandPrint, "top-right");

        });


        //search

         //search widget

        // const searchWidget = new Search({
        //   view: mapView
        // });
        // // Adds the search widget below other elements in
        // // the top left corner of the view
        // mapView.ui.add(searchWidget, {
        //   position: "top-left",
        //   index: 2
        // });


       //legend

   

        const legend = new Legend({
          view: mapView,
          layerInfos: [
            { layer: PropertyFeatureLayer, title: "Property Layer" },
            { layer: masterPlanGroup, title: "Master Plan" },
            { layer: group8, title: "Others" },
            { layer: group7, title: "Utilities" },
            { layer: group6, title: "Important Landmarks" },
            { layer: group5, title: "Waterbodies" },
            { layer: group4, title: "Transportation" },
            { layer: group3, title: "Landuse and Landcover" },
            { layer: group2, title: "Property" },
            { layer: group1, title: "Administrative Boundaries" },
          ],
        });

        const legendExpand = new Expand({
            view: mapView,
            content: legend,
            expandIconClass: "esri-icon-legend",
            expandTooltip: "legend"
          });

          mapView.ui.add(legendExpand, "top-right");


      
      } catch (error) {
        console.error("Error initializing the map:", error);
        setLoading(false);
      }
    };

    initializeMap();

    return () => {
      if (mapView) {
        mapView.destroy(); // Properly clean up the map
      }
    };
  }, [authData]);

  useEffect(() => {
    const handleResize = () => {
      setIsScreenSize1(window.innerWidth <= 991)
    };
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])



  const calculatedHeight = useMemo(() => {
    const hasFeatureTableData = setFeatureTable?.length > 0;
    if (isWidth && isByDefaultActive) {
      return "calc(100vh - 78px)"; // Adjust height as needed
    }
    if (isScreenSize1) {
      return tabLocation === "/user-chatbot" ? "calc(100vh - 200px)" : "calc(80vh - 78px)";
    }
    if (tabLocation) {
      return "calc(100vh - 78px)";
    }
    if (isDrag) {
      return "0px";
    }
    if (isWidth) {
      return hasFeatureTableData ? "calc(100vh - 285px)" : "calc(100vh - 78px)";
    }
    if (isWidth) {
      return "calc(100vh - 78px)"
    }
    if (!isWidth && hasFeatureTableData) {
      return isToolHeight ? "calc(100vh - 280px)" : "calc(100vh - 375px)";
    }
    if (!isWidth && hasFeatureTableData && isByDefaultActive) {
      return isToolHeight ? "calc(100vh - 108px)" : "calc(100vh - 375px)";
    }
    if (isBufferWidth && isToolHeight) {
      return "calc(100vh - 110px)"
    }
    if (isToolHeight) {
      return "calc(100vh - 108px)"
    }

    return  graph ? "calc(100vh - 300px)" : "calc(100vh - 200px)";
  }, [tabLocation, isDrag, isWidth, setFeatureTable, isBufferWidth, isScreenSize, isScreenSize1, isByDefaultActive, isToolHeight]);




  const handleAccordian = (index) => {
    if (selectedBuffer === index) {
      dispatch(setSelectedBuffer(null));
      setIsDrag(true);
      setIsAccordian(null);
    } else {
      // Open the clicked accordion
      dispatch(setSelectedBuffer(index));
      setIsDrag(true);
      setIsAccordian(index);
    }

  };

  // const downloadPropertyData = async () => {
  //   const relationIds1 = JSON.parse(localStorage.getItem("relationIds") || "[]")
  //     .map(id => id.replace(/^'|'$/g, "")); // Remove extra quotes

  //   const selectedUlb = localStorage.getItem("selectedUlb");
  //   if (!selectedUlb || relationIds1.length === 0) {
  //     console.log("No valid relation IDs or ULB selected.");
  //     return;
  //   }

  //   let allData = []; // Hold all API responses
  //   let startIndex = 0;
  //   const batchSize = 100; // Process in batches of 100

  //   while (startIndex < relationIds1.length) {
  //     // Take the next 100 IDs
  //     const idsToProcess = relationIds1.slice(startIndex, startIndex + batchSize);
  //     const relationIds = idsToProcess.map(id => `'${id.trim()}'`).join(",");

  //     // Fetch API Data
  //     const updateData = await getNewTableData(relationIds, selectedUlb);

  //     // Stop if no data is returned
  //     if (!updateData || updateData.length === 0) {
  //       console.log("No more data found. Stopping.");
  //       break;
  //     }

  //     // Store data from API response
  //     allData = [...allData, ...updateData];

  //     startIndex += batchSize; // Move to next batch
  //   }

  //   if (allData.length) {
  //     exportData(allData, "Properties"); // Proceed with export
  //   } else {
  //     console.log("No data available for export.");
  //   }
  //   // You can now use allData as needed (e.g., export to Excel)
  // };

  const downloadPropertyData = async (bufferData) => {
    if (bufferData.length) {
      exportData(bufferData, "Properties");
    } else {
      console.log("No data available for export.");
    }
  };

  const exportData = async (data, layerName) => {
    if (layerName === "Properties" && data.length) {
      const tableHeaders = [
        "Serial No", "GIS Unique ID", "Divisionname", "Districtname", "Ulbcode", "Ulbname", "E Nagarpalika ID", "Owner Name", "No of Floor",
        "Area(sqrft)", "Ward No", "Mobile No", "Property Type", "Aadhar card no", "Bpl card", "City", "Colony", 'Concessdetails', "Concesstypecode", "Constructiontype", "Constructiontypecode",
        "Constructionyear", "Dist cd", "Div cd", "Electricity id", "Floordetails", "Gislinkid", "Ifcommercial", "Ifnoormixusecode", "Ifnoormixusedetails", "Ihtoiletk", "Ihtoiletyn",
        "Khasra no", "Licamount", "Licensetype", "Licissueby", "Licrnwdate", "Licyear", "Locality", "Noofhh", "Ownerdetail", "Ownergardianname", "Parcelno",
        "Patta no", "Phouseno", "Pin", "Plintharea", "Pownershipcode", "Pownershipdetails", "Property", "Property tax rate", "Propertylattitude", "Propertylongitude", "Propertyno", "Ptaxno", "Rebate code", "Registration no", "Relation id", "Remark",
        "Res resl with owner", "Respondentname", "Result", "Saf", "Satatid", "Seweragecategory", "Seweragemonthlyrate", "Singlepage", "Situationcode", "Situationdetails", "Slumid", "Slumname", "Status", "Streetno", "Surveydetails", "Surveyour", "Swmd2d", "Swmd2dby",
        "Swmd2dcode", "Swmd2ddetails", "Ta builtuparea", 'Taxzonename e', "Total due", "Total property tax", "Ulb cd", "Ulbtype", "Uniqueid", 'Vlandarea', "Wardname", "Wardno", "Wscharge", "Wschargedt", "Wsconncount", "Wsconnno", "Wsmunconn", 'Wssldia', "Wstyofusecode", "Wstyofusedetails"

      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Apply header styles
      const headerRow = worksheet.addRow(tableHeaders);
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "C4C4C4" } // Light gray background
        };
        cell.font = { bold: true, color: { argb: "000000" } }; // Black text
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      // Add data rows with alternating row colors
      data.forEach((row, index) => {
        const rowData = [
          index + 1,
          row.gis_uniqueid || "",
          row.divisionname || "-",
          row.districtname || "-",
          row.ulbcode || "-",
          row.ulbname || "-",
          row.e_nagarpalikaid || "",
          row.ownername || "-",
          row.nooffloor || "-",
          row.plotsize || "-",
          row.wardno || "-",
          row.mobileno || "-",
          row.isuseres === "Yes" ? "Residential" : row.isuseres === "No" ? "Commercial" : "Both",
          row.aadhar_card_no || "-",
          row.bpl_card || "-",
          row.city || "-",
          row.colony || "-",
          row.concessdetails || "-",
          row.concesstypecode || "-",
          row.constructiontype || "-",
          row.constructiontypecode || "-",
          row.constructionyear || "-",
          row.dist_cd || "-",
          row.div_cd || "-",
          row.electricity_id || "-",
          row.floordetails || "-",
          row.gislinkid || "-",
          row.ifcommercial || "-",
          row.ifnoormixusecode || "-",
          row.ifnoormixusedetails || "-",
          row.ihtoiletk || "-",
          row.ihtoiletyn || "-",
          row.khasra_no || "-",
          row.licamount || "-",
          row.licensetype || "-",
          row.licissueby || "-",
          row.licrnwdate || "-",
          row.licyear || "-",
          row.locality || "-",
          row.noofhh || "-",
          row.ownerdetail || "-",
          row.ownergardianname || "-",
          row.parcelno || "-",
          row.patta_no || "-",
          row.phouseno || "-",
          row.pin || "-",
          row.plintharea || "-",
          row.pownershipcode || "-",
          row.pownershipdetails || "-",
          row.property || "-",
          row.property_tax_rate || "-",
          row.propertylattitude || "-",
          row.propertylongitude || "-",
          row.propertyno || "-",
          row.ptaxno || "-",
          row.rebate_code || "-",
          row.registration_no || "-",
          row.relation_id || "-",
          row.remark || "-",
          row.res_resl_with_owner || "-",
          row.respondentname || "-",
          row.result || "-",
          row.saf || "-",
          row.satatid || "-",
          row.seweragecategory || "-",
          row.seweragemonthlyrate || "-",
          row.singlepage || "-",
          row.situationcode || "-",
          row.situationdetails || "-",
          row.slumid || "-",
          row.slumname || "-",
          row.status || "-",
          row.streetno || "-",
          row.surveydetails || "-",
          row.surveyour || "-",
          row.swmd2d || "-",
          row.swmd2dby || "-",
          row.swmd2dcode || "-",
          row.swmd2ddetails || "-",
          row.ta_builtuparea || "-",
          row.taxzonename_e || "-",
          row.total_due || "-",
          row.total_property_tax || "-",
          row.ulb_cd || "-",
          row.ulbtype || "-",
          row.uniqueid || "-",
          row.vlandarea || "-",
          row.wardname || "-",
          row.wardno || "-",
          row.wscharge || "-",
          row.wschargedt || "-",
          row.wsconncount || "-",
          row.wsconnno || "-",
          row.wsmunconn || "-",
          row.wssldia || "-",
          row.wstyofusecode || "-",
          row.wstyofusedetails || "-"
        ];

        const dataRow = worksheet.addRow(rowData);
        const backgroundColor = index % 2 === 0 ? "F0FFF0" : "FFFFFF" // White & Light Green
        // Apply alternating row background color
        dataRow.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: backgroundColor }
          };
          cell.font = { color: { argb: "000000" } };
          cell.alignment = { horizontal: "center", vertical: "middle" };
          cell.border = {
            top: { style: "thin", color: { argb: "A9A9A9" } },
            left: { style: "thin", color: { argb: "A9A9A9" } },
            bottom: { style: "thin", color: { argb: "A9A9A9" } },
            right: { style: "thin", color: { argb: "A9A9A9" } }
          };
        });
      });

      // Auto-adjust column widths
      worksheet.columns.forEach((column) => {
        column.width = 20; // Adjust as needed
      });

      // Generate the Excel file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      // Save the file
      saveAs(blob, `${layerName}_data.xlsx`);
    } else {
      console.log("No data available for export.");
    }
  };

  const getNewTableData = async (relationIds, selectedUlb) => {
    setLoading(true)
    if (!relationIds || !selectedUlb) {
      setLoading(false)
      console.log("No relationIds or selectedUlb provided!");
      return [];
    }
    try {
      const encodedIds = encodeURIComponent(`${relationIds}`);
      const encodedUlb = encodeURIComponent(selectedUlb);
      const apiUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/FeatureServer/96/query?where=ulb_cd%3D%27${encodedUlb}%27+and+relation_id+in+%28${encodedIds}%29&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&defaultSR=&spatialRel=esriSpatialRelRelation&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=&returnTrueCurves=false&returnCentroid=false&timeReferenceUnknownClient=false&maxRecordCountFactor=&sqlFormat=none&resultType=&featureEncoding=esriDefault&datumTransformation=&cacheHint=false&f=pjson`

      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();

      if (data) {
        setLoading(false)
      }
      return data.features?.map(f => f.attributes) || [];
    } catch (error) {
      console.log("Error fetching data:", error);
      return [];
    }
  };

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }




  const downloadTableData = (features, layerName, bufferData) => {
    if (layerName === "Properties") {
      // downloadPropertyData()
      downloadPropertyData(bufferData?.properties)
    } else {
      if (!features || features.length === 0) {
        throw new Error("No features available for export.");
      }

      // Dynamically get headers from the first object in features
      let tableHeaders = ["Serial No", ...Object.keys(features[0])];

      // Generate table rows dynamically
      let tableRows = features.map((row, index) => {
        let rowColor = index % 2 === 0 ? "honeydew" : "white"; // Alternating row colors

        // Dynamically create table cells
        let rowData = Object.keys(row)
          .map(key => `<td style="border: 1px solid darkgray;">${row[key] || "-"}</td>`)
          .join("");

        return `
          <tr style="background-color: ${rowColor}; color: black; text-align: center;">
              <td style="border: 1px solid darkgray;">${index + 1}</td>
              ${rowData}
          </tr>`;
      }).join("");

      // Generate the final table HTML
      let tableHTML = `
      <table border="1">
          <thead>
              <tr style="background-color: #C4C4C4; font-weight: bold;">
                  ${tableHeaders.map(header => `<th>${capitalizeFirstLetter(header)}</th>`).join("")}
              </tr>
          </thead>
          <tbody>
              ${tableRows}
          </tbody>
      </table>`;

      // Create and trigger download for Excel file
      let excelBlob = new Blob([tableHTML], { type: "application/vnd.ms-excel" });
      let url = URL.createObjectURL(excelBlob);
      let a = document.createElement("a");
      a.href = url;
      a.download = `${layerName}_data.xls`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  };


  const printTableData = async (features, layerName, bufferData) => {
    try {
      let tableHeaders = [];
      let tableRows = [];

      if (layerName === "Properties") {
        const relationIds1 = JSON.parse(localStorage.getItem("relationIds") || "[]")
          .map(id => id.replace(/^'|'$/g, "")); // Clean up extra quotes

        const selectedUlb = localStorage.getItem("selectedUlb");
        if (!selectedUlb || relationIds1.length === 0) {
          console.log("No valid relation IDs or ULB selected.");
          return;
        }

        let allData = []; // Hold all API responses
        const batchSize = 100; // Process in batches of 100
        let startIndex = 0;

        while (startIndex < relationIds1.length) {
          const idsToProcess = relationIds1.slice(startIndex, startIndex + batchSize);
          const relationIds = idsToProcess.map(id => `'${id.trim()}'`).join(",");

          // Fetch API Data
          const updateData = await getNewTableData(relationIds, selectedUlb);
          if (!updateData || updateData.length === 0) {
            console.log("No more data found. Stopping.");
            break;
          }

          allData = [...allData, ...updateData];
          startIndex += batchSize;
        }

        console.log("All API Data:", allData);

        if (!allData.length) {
          console.log("No data available after API fetch.");
          return;
        }

        features = allData;

        // Define specific headers for "Properties" layer with renamed columns
        const headerMapping = {
          "Serial No": "serial_no",
          "GIS Unique ID": "gis_uniqueid",
          "E Nagarpalika ID": "e_nagarpalikaid",
          "Owner Name": "ownername",
          "No. of Floors": "nooffloor",
          "Area (sqft)": "plotsize",
          "Ward No": "wardno",
          "Mobile No": "mobileno",
          "Property Type": "isuseres",
        };

        tableHeaders = Object.keys(headerMapping);
        tableRows = features.map((row, index) => {
          return `<tr>${tableHeaders
            .map(header => {
              let value = "-";
              if (header === "Serial No") {
                value = index + 1; // Assign serial number
              } else if (header === "Property Type") {
                value =
                  row.isuseres === "Yes" ? "Residential" :
                    row.isuseres === "No" ? "Commercial" :
                      row.isuseres === "Mix Use" ? "Both" :
                        "Unknown";
              } else {
                value = row[headerMapping[header]] || "-"; // Use mapped key
              }
              return `<td>${value}</td>`;
            }).join("")}
          </tr>`;
        });

      } else {
        if (!features || features.length === 0) {
          console.log("No data available to print.");
          return;
        }

        tableHeaders = ["Serial No", ...Object.keys(features[0])];
        tableRows = features.map((feature, index) => {
          return `<tr>${tableHeaders
            .map(header => {
              let value = header === "Serial No" ? index + 1 : feature[header] ?? "-";
              return `<td>${value}</td>`;
            }).join("")}
          </tr>`;
        });
      }

      // Generate the HTML content for printing
      const printContent = `
        <!DOCTYPE html>
        <html>
          <head>
            <title>${layerName}</title>
            <style>
              @media print {
                @page { margin: 20px; }
              }
              body { font-family: Arial, sans-serif; padding: 20px; }
              h2 { text-align: center; margin-bottom: 20px; }
              table { width: 100%; border-collapse: collapse; margin-top: 10px; page-break-inside: auto; }
              tr { page-break-inside: avoid; page-break-after: auto; }
              th, td { border: 1px solid black; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
              @media print {
                th { background-color: #f2f2f2 !important; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
              }
            </style>
          </head>
          <body>
            <h2>${layerName}</h2>
            <table>
              <thead>
                <tr>${tableHeaders.map(header => `<th>${header}</th>`).join("")}</tr>
              </thead>
              <tbody>
                ${tableRows.join("")}
              </tbody>
            </table>
          </body>
        </html>
      `;

      // Create a hidden iframe for printing
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      document.body.appendChild(iframe);

      const iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(printContent);
      iframeDocument.close();

      iframe.onload = () => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (printError) {
          console.log("Error printing the table:", printError);
        }
        setTimeout(() => document.body.removeChild(iframe), 1000);
      };

    } catch (error) {
      console.log("Error generating print data:", error);
    }
  };

  const handleToggleBufferWidth = () => {
    dispatch(setIsBufferWidth(!isBufferWidth));
  };
  const handleToggleBufferLeft = () => {
    dispatch(setIsSidebar(!isSideBar));
  };



  return (
    < div className='position-relative'>
      <Loader isLoader={loading} />
      <div
        ref={mapRef}
        style={{
          width: "100%",
          height: calculatedHeight,
          overflow: "hidden",
        }}
      />

      {currentStageValue === 0 ? "" :
        <div className={isWidth ? "d-none" : 'manage-buffer'} type="button" onClick={handleToggleBufferWidth}>
          <div className={isBufferWidth ? 'not-rotate' : 'is-rotate'}>
            <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
          </div>
        </div>
      }
      {currentStageValue === 0 ? "" :
        <div className={isWidth ? "d-none" : 'manage-buffer-left'} type="button" onClick={handleToggleBufferLeft}
        >
          <div className={isBufferWidth ? 'is-rotate' : 'not-rotate'}>
            <img src="img/horizontal-arrow.svg" alt='drag' className='buffer-img-arrow' />
          </div>
        </div>
      }



      {!isByDefaultActive && (
        <div className="position-relative">
          {location.pathname !== "/user-chatbot" && setFeatureTable.length > 0 && (
            <div className={isDrag ? 'isDragdiv' : 'dragdiv'} type="button" onClick={handleDrag}>
              <div className={isDrag ? 'not-rotate' : 'is-rotate'}>
                <img src="img/drag.svg" alt='drag' height="12px" width="12px" />
              </div>
              <div>
                <h6 className="viewmoretitle">{isDrag ? "View less data" : "View more data"}</h6>
              </div>
            </div>
          )}

          {setFeatureTable.length > 0 && (
            <h6 className="tabletitlefeature">Feature Data</h6>
          )}

          {setFeatureTable.length > 0 && (
            <div className={`${isDrag ? (isToolHeight ? "table-isdrag isDragActive" : "table-isdrag isDragWidth") : "maptablediv collapsed table-isdrag"}`}>
              <div className="accordion accordion-flush" id="accordionFlushExample">
                {setFeatureTable.map((buffer, index) => {
                  const isOpen = selectedBuffer === index; // Track open/close state correctly
                  return (
                    <div className="accordion-item" key={index}>
                      <h2 className="accordion-header" id={`flush-heading-${index}`} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        {/* Accordion Toggle Button */}
                        <button
                          className={`accordion-button ${isOpen ? '' : 'collapsed'}`}
                          onClick={(e) => {
                            // e.stopPropagation();
                            handleAccordian(index);
                          }}
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse-${index}`}
                          aria-expanded={isOpen ? "true" : "false"}
                          aria-controls={`collapse-${index}`}
                          style={{ flex: "1", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}
                        >
                          {buffer.layer} ({buffer.features.length})

                          {/* Download & Print Buttons */}
                          <div className="tabledownloaddiv">
                            <span
                              className={`download-btn ${isOpen ? 'downloadline' : 'isdownloadline'}`}
                              onClick={(e) => {
                                // e.stopPropagation();
                                printTableData(buffer.features, buffer.layer, bufferData);
                              }}
                              style={{ color: "black", textDecoration: "none", cursor: "pointer", display: "flex", alignItems: "center" }}
                            >
                              <img src="img/print.svg" alt="print" /> Print
                            </span>

                            <span
                              className={`download-btn ${isOpen ? 'downloadline' : 'isdownloadline'}`}
                              onClick={(e) => {
                                // e.stopPropagation();
                                downloadTableData(buffer.features, buffer.layer, bufferData);
                              }}
                              style={{ color: "black", textDecoration: "none", cursor: "pointer", display: "flex", alignItems: "center" }}
                            >
                              <img src="img/downloadtable.svg" alt="download" /> Download
                            </span>
                          </div>
                        </button>
                      </h2>


                      <div
                        id={`collapse-${index}`}
                        className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}
                        aria-labelledby={`flush-heading-${index}`}
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body">
                          <Table bufferFeatures={buffer?.features} bufferDataOne={bufferData?.properties} bufferLayer={buffer?.layer} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MapComponent;
